"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { Heart, ShieldCheck } from "lucide-react";
const experts = [{
  name: "Viktor Volkov",
  position: "Technical SEO Lead",
  bio: "Specialista in architetture server-side e ottimizzazione per l'indice Yandex YATI.",
  favoriteZone: "Infrastruttura RuNet",
  certification: "Yandex Certified Expert",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591142/img/viktor_volkov_seo.png"
}, {
  name: "Elena Petrova",
  position: "Compliance Officer",
  bio: "Esperta in normativa FZ-152 e sovranità dei dati per il mercato della Federazione Russa.",
  favoriteZone: "Data Sovereignty",
  certification: "GDPR & FZ-152 Specialist",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591142/img/elena_petrova_compliance.png"
}, {
  name: "Dmitry Sokolov",
  position: "B2B Lead Strategist",
  bio: "Oltre 15 anni di esperienza nella generazione di lead complessi per il settore industriale CSI.",
  favoriteZone: "Yandex Direct B2B",
  certification: "Strategic Marketing Lead",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591142/img/dmitry_sokolov_strategy.png"
}, {
  name: "Svetlana Ivanova",
  position: "VKontakte Specialist",
  bio: "Architetto di campagne social ad alto impatto su VK e piattaforme native MyTarget.",
  favoriteZone: "Social Ecosystems",
  certification: "VK Ads Certified",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591142/img/svetlana_ivanova_social.png"
}];
export default function MeetThePlayExperts() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223765" id="esperti-di-settore" className="bg-background text-foreground py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-default font-bold text-foreground mb-6 tracking-tight uppercase">
            Intelligence Team
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            Un nucleo d'élite di consulenti senior dedicati alla padronanza algoritmica 
            e all'accessibilità tecnica nel mercato digitale russo.
          </p>
        </div>

        <div ref={ref} className={cn("grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {experts.map((expert, i) => <div data-index={i} key={i} className="flex flex-col items-center">
              {}
              <div className="group relative aspect-square w-full max-w-[280px] mb-6 [perspective:1000px]">
                <div className="relative h-full w-full transition-transform duration-700 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)] shadow-xl rounded-none">
                  
                  {}
                  <div className="absolute inset-0 h-full w-full [backface-visibility:hidden]">
                    <SafeHydrate><Avatar className="size-full rounded-none border-2 border-secondary/30 shadow-lg grayscale hover:grayscale-0 transition-all duration-500">
                      <AvatarImage src={expert.image} alt={expert.name} className="object-cover" />
                      <AvatarFallback className="rounded-none bg-muted text-primary text-4xl font-default font-bold">
                        {expert.name.charAt(0)}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                  </div>

                  {}
                  <div className="absolute inset-0 h-full w-full rounded-none bg-card/95 backdrop-blur-md p-6 text-foreground [backface-visibility:hidden] [transform:rotateY(180deg)] flex flex-col justify-center items-center text-center shadow-2xl border border-secondary/50">
                    <p className="text-sm md:text-base font-sans font-medium mb-6 leading-relaxed text-muted-foreground">
                      "{expert.bio}"
                    </p>
                    <div className="mt-auto flex flex-col items-center gap-2">
                      <div className="flex items-center gap-1.5 text-secondary">
                        <Heart className="size-4" />
                        <span className="text-[10px] uppercase tracking-widest font-mono font-bold">
                          Focus Area
                        </span>
                      </div>
                      <span className="font-default font-semibold text-lg text-primary">
                        {expert.favoriteZone}
                      </span>
                    </div>
                  </div>

                </div>
              </div>

              {}
              <div className="text-center flex flex-col items-center">
                <h3 className="text-xl font-default font-bold text-foreground mb-1 tracking-tight">
                  {expert.name}
                </h3>
                <p className="text-secondary font-mono text-xs uppercase tracking-wider mb-4">
                  {expert.position}
                </p>
                <Badge variant="secondary" className="bg-primary/10 text-primary hover:bg-primary/20 border-primary/30 rounded-none px-3 py-1">
                  <ShieldCheck className="size-3.5 mr-1.5" />
                  <span className="text-[10px] font-mono font-bold">{expert.certification}</span>
                </Badge>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}